import {Verses} from './verses';

export class Hymn {
  english?: string;
  hymnNumber!: number;
  reference!: string;
  title!: string;
  hasMidi!: boolean;
  numberOfVerses!: number;
  hasChorus!: boolean;
  startsWithChorus?: boolean;
  verses!: Verses[];
  chorus?: string[] | null;
  timestamps?: {
    chorus?: number,
    intro?: number,
    introEnd?: number,
  }
  youtube?: string;

  constructor(english: string, hymnNumber: number, reference: string, title: string, hasMidi: boolean, numberOfVerses: number, hasChorus: boolean, startsWithChorus: boolean, verses: Verses[], chorus?: string[] | null) {
    this.english = english;
    this.hymnNumber = hymnNumber;
    this.reference = reference;
    this.title = title;
    this.hasMidi = hasMidi;
    this.numberOfVerses = numberOfVerses;
    this.hasChorus = hasChorus;
    this.startsWithChorus = startsWithChorus;
    this.verses = verses;
    this.chorus = chorus;
  }

  // Static method does not use 'this', it works with passed parameters
  static getChorus(hymn: Hymn, verseNumber: number): string[] | null {
    if (hymn?.verses[verseNumber-1]?.chorus) {
      return hymn.verses[verseNumber-1].chorus!;
    } else if (hymn?.chorus) {
      return hymn.chorus;
    } else {
      return null;
    }
  }
}
